import Login from "../components/authentication/Login";
import Password from "../components/authentication/Password";

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { requiresVisitor: true },
  },
  {
    path: "/password",
    name: "password",
    component: Password,
    meta: { requiresVisitor: true },
  },
];

export default routes;
